import Box from 'component/layoutComponents/Box';
import styled from 'styled-components';

export const StyledDrawerContent = styled(Box)(({ theme }) => `
  display: flex;
  flex-direction: column;
  height: 100%;
`);

export const StyledForm = styled(Box)(({ theme }) => `
  flex: 1;
  padding: ${theme.uptimeSpace[8]}px;
  display: flex;
  flex-direction: column;
  gap: ${theme.uptimeSpace[10]}px;
  overflow: auto;

  .MuiCircularProgress-svg {
    width: 100%;
    height: 100%;
  }
`);

export const StyledActions = styled(Box)(({ theme }) => `
  padding: ${theme.uptimeSpace[8]}px;
  display: flex;
  gap: ${theme.uptimeSpace[4]}px;
  justify-content: flex-end;
`);

export const DatePickerWrapper = styled(Box)(({ theme }) => `
  .MuiFormControl-root {
    width: 100%;
  }
`);
